var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 413.735,
    height: 439.825,
    viewBox: "0 0 413.735 439.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16247",
    "data-name": "Group 16247",
    transform: "translate(-42.407 -29.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15745",
    "data-name": "Group 15745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15602",
    "data-name": "Group 15602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15488",
    "data-name": "Group 15488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15487",
    "data-name": "Group 15487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15397",
    "data-name": "Group 15397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15396",
    "data-name": "Group 15396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15395",
    "data-name": "Group 15395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15394",
    "data-name": "Group 15394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15393",
    "data-name": "Group 15393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15392",
    "data-name": "Group 15392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15391",
    "data-name": "Group 15391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15390",
    "data-name": "Group 15390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15389",
    "data-name": "Group 15389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15388",
    "data-name": "Group 15388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15387",
    "data-name": "Group 15387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15386",
    "data-name": "Group 15386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15385",
    "data-name": "Group 15385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15384",
    "data-name": "Group 15384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63113",
    "data-name": "Path 63113",
    d: "M60.422,413.6,42.447,438.011,72.706,460.53c1.975-3.023-9.361-20.476-9.361-20.476L75.5,424.884Z",
    fill: "#455a64"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15412",
    "data-name": "Group 15412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15411",
    "data-name": "Group 15411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15410",
    "data-name": "Group 15410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15409",
    "data-name": "Group 15409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15408",
    "data-name": "Group 15408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15407",
    "data-name": "Group 15407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15406",
    "data-name": "Group 15406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15405",
    "data-name": "Group 15405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15404",
    "data-name": "Group 15404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15403",
    "data-name": "Group 15403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15402",
    "data-name": "Group 15402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15401",
    "data-name": "Group 15401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15400",
    "data-name": "Group 15400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15399",
    "data-name": "Group 15399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15398",
    "data-name": "Group 15398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63114",
    "data-name": "Path 63114",
    d: "M54.964,431.78a1.54,1.54,0,0,0-1.9.774,1.481,1.481,0,0,0,.751,1.894,1.625,1.625,0,0,0,2.012-.831,1.535,1.535,0,0,0-1-1.883",
    fill: "#fff"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15426",
    "data-name": "Group 15426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15425",
    "data-name": "Group 15425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15424",
    "data-name": "Group 15424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15423",
    "data-name": "Group 15423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15422",
    "data-name": "Group 15422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15421",
    "data-name": "Group 15421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15420",
    "data-name": "Group 15420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15419",
    "data-name": "Group 15419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15418",
    "data-name": "Group 15418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15417",
    "data-name": "Group 15417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15416",
    "data-name": "Group 15416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15415",
    "data-name": "Group 15415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15414",
    "data-name": "Group 15414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15413",
    "data-name": "Group 15413"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63115",
    "data-name": "Path 63115",
    d: "M42.407,438.06l1.913-2.623L72.591,458.2s.9,1.6.037,2.425Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15441",
    "data-name": "Group 15441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15440",
    "data-name": "Group 15440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15439",
    "data-name": "Group 15439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15438",
    "data-name": "Group 15438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15437",
    "data-name": "Group 15437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15436",
    "data-name": "Group 15436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15435",
    "data-name": "Group 15435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15434",
    "data-name": "Group 15434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15433",
    "data-name": "Group 15433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15432",
    "data-name": "Group 15432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15431",
    "data-name": "Group 15431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15430",
    "data-name": "Group 15430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15429",
    "data-name": "Group 15429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15428",
    "data-name": "Group 15428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15427",
    "data-name": "Group 15427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63116",
    "data-name": "Path 63116",
    d: "M63.95,440.265c-.115.144-.9-.339-1.984-.405-1.079-.094-1.93.267-2.023.108-.115-.13.763-.85,2.07-.747S64.083,440.153,63.95,440.265Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15456",
    "data-name": "Group 15456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15455",
    "data-name": "Group 15455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15454",
    "data-name": "Group 15454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15453",
    "data-name": "Group 15453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15452",
    "data-name": "Group 15452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15451",
    "data-name": "Group 15451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15450",
    "data-name": "Group 15450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15449",
    "data-name": "Group 15449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15448",
    "data-name": "Group 15448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15447",
    "data-name": "Group 15447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15446",
    "data-name": "Group 15446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15445",
    "data-name": "Group 15445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15444",
    "data-name": "Group 15444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15443",
    "data-name": "Group 15443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15442",
    "data-name": "Group 15442"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63117",
    "data-name": "Path 63117",
    d: "M66.147,443.939c-.073.169-.9-.056-1.867.2-.974.223-1.6.8-1.746.689-.156-.08.386-1.022,1.594-1.312S66.248,443.8,66.147,443.939Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15471",
    "data-name": "Group 15471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15470",
    "data-name": "Group 15470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15469",
    "data-name": "Group 15469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15468",
    "data-name": "Group 15468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15467",
    "data-name": "Group 15467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15466",
    "data-name": "Group 15466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15465",
    "data-name": "Group 15465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15464",
    "data-name": "Group 15464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15463",
    "data-name": "Group 15463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15462",
    "data-name": "Group 15462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15461",
    "data-name": "Group 15461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15460",
    "data-name": "Group 15460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15459",
    "data-name": "Group 15459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15458",
    "data-name": "Group 15458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15457",
    "data-name": "Group 15457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63118",
    "data-name": "Path 63118",
    d: "M65.122,449.079c-.157-.068.187-.959,1.168-1.486s1.913-.335,1.883-.165c-.007.183-.778.284-1.578.728C65.786,448.582,65.28,449.174,65.122,449.079Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15486",
    "data-name": "Group 15486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15485",
    "data-name": "Group 15485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15484",
    "data-name": "Group 15484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15483",
    "data-name": "Group 15483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15482",
    "data-name": "Group 15482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15481",
    "data-name": "Group 15481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15480",
    "data-name": "Group 15480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15479",
    "data-name": "Group 15479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15478",
    "data-name": "Group 15478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15477",
    "data-name": "Group 15477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15476",
    "data-name": "Group 15476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15475",
    "data-name": "Group 15475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15474",
    "data-name": "Group 15474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15473",
    "data-name": "Group 15473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15472",
    "data-name": "Group 15472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63119",
    "data-name": "Path 63119",
    d: "M66.337,436.5c-.162.089-.688-.619-1.565-1.184-.867-.583-1.725-.786-1.708-.97-.005-.171,1.036-.245,2.06.434S66.5,436.438,66.337,436.5Z",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15490",
    "data-name": "Group 15490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15489",
    "data-name": "Group 15489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63120",
    "data-name": "Path 63120",
    d: "M133.576,311.456c.548,3.062,1.4,29.092,1.95,42.82s-.819,20.489-2.387,23.562S72.357,424.553,67.849,435L52.892,422.914s21.957-39.5,31.382-46.669S111.7,362.471,111.7,362.471l-5.123-75.194,24.587-1.341Z",
    fill: "#419325"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15601",
    "data-name": "Group 15601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15595",
    "data-name": "Group 15595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15594",
    "data-name": "Group 15594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15504",
    "data-name": "Group 15504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15503",
    "data-name": "Group 15503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15502",
    "data-name": "Group 15502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15501",
    "data-name": "Group 15501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15500",
    "data-name": "Group 15500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15499",
    "data-name": "Group 15499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15498",
    "data-name": "Group 15498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15497",
    "data-name": "Group 15497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15496",
    "data-name": "Group 15496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15495",
    "data-name": "Group 15495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15494",
    "data-name": "Group 15494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15493",
    "data-name": "Group 15493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15492",
    "data-name": "Group 15492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15491",
    "data-name": "Group 15491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63121",
    "data-name": "Path 63121",
    d: "M78.55,437.728l-.263,30.315,37.715.52c-.171-3.606-19.583-11.108-19.583-11.108l.965-19.417Z",
    fill: "#455a64"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15519",
    "data-name": "Group 15519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15518",
    "data-name": "Group 15518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15517",
    "data-name": "Group 15517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15516",
    "data-name": "Group 15516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15515",
    "data-name": "Group 15515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15514",
    "data-name": "Group 15514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15513",
    "data-name": "Group 15513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15512",
    "data-name": "Group 15512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15511",
    "data-name": "Group 15511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15510",
    "data-name": "Group 15510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15509",
    "data-name": "Group 15509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15508",
    "data-name": "Group 15508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15507",
    "data-name": "Group 15507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15506",
    "data-name": "Group 15506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15505",
    "data-name": "Group 15505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63122",
    "data-name": "Path 63122",
    d: "M84.78,455.66a1.539,1.539,0,0,0-1.089,1.743,1.48,1.48,0,0,0,1.718,1.095,1.626,1.626,0,0,0,1.143-1.852,1.536,1.536,0,0,0-1.913-.94",
    fill: "#fff"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15533",
    "data-name": "Group 15533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15532",
    "data-name": "Group 15532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15531",
    "data-name": "Group 15531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15530",
    "data-name": "Group 15530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15529",
    "data-name": "Group 15529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15528",
    "data-name": "Group 15528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15527",
    "data-name": "Group 15527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15526",
    "data-name": "Group 15526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15525",
    "data-name": "Group 15525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15524",
    "data-name": "Group 15524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15523",
    "data-name": "Group 15523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15522",
    "data-name": "Group 15522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15521",
    "data-name": "Group 15521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15520",
    "data-name": "Group 15520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63123",
    "data-name": "Path 63123",
    d: "M78.283,468.107l.014-3.246,36.248,1.883s1.664.764,1.45,1.943Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15548",
    "data-name": "Group 15548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15547",
    "data-name": "Group 15547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15546",
    "data-name": "Group 15546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15545",
    "data-name": "Group 15545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15544",
    "data-name": "Group 15544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15543",
    "data-name": "Group 15543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15542",
    "data-name": "Group 15542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15541",
    "data-name": "Group 15541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15540",
    "data-name": "Group 15540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15539",
    "data-name": "Group 15539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15538",
    "data-name": "Group 15538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15537",
    "data-name": "Group 15537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15536",
    "data-name": "Group 15536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15535",
    "data-name": "Group 15535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15534",
    "data-name": "Group 15534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63124",
    "data-name": "Path 63124",
    d: "M97.033,457.272c-.008.184-.93.254-1.845.834-.929.556-1.407,1.347-1.576,1.272-.169-.038.121-1.135,1.24-1.818S97.075,457.1,97.033,457.272Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15563",
    "data-name": "Group 15563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15562",
    "data-name": "Group 15562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15561",
    "data-name": "Group 15561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15560",
    "data-name": "Group 15560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15559",
    "data-name": "Group 15559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15558",
    "data-name": "Group 15558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15557",
    "data-name": "Group 15557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15556",
    "data-name": "Group 15556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15555",
    "data-name": "Group 15555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15554",
    "data-name": "Group 15554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15553",
    "data-name": "Group 15553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15552",
    "data-name": "Group 15552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15551",
    "data-name": "Group 15551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15550",
    "data-name": "Group 15550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15549",
    "data-name": "Group 15549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63125",
    "data-name": "Path 63125",
    d: "M100.966,458.962c.04.179-.762.481-1.4,1.252-.659.751-.828,1.591-1.012,1.581-.173.026-.286-1.054.524-2S100.965,458.786,100.966,458.962Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15578",
    "data-name": "Group 15578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15577",
    "data-name": "Group 15577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15576",
    "data-name": "Group 15576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15575",
    "data-name": "Group 15575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15574",
    "data-name": "Group 15574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15573",
    "data-name": "Group 15573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15572",
    "data-name": "Group 15572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15571",
    "data-name": "Group 15571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15570",
    "data-name": "Group 15570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15569",
    "data-name": "Group 15569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15568",
    "data-name": "Group 15568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15567",
    "data-name": "Group 15567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15566",
    "data-name": "Group 15566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15565",
    "data-name": "Group 15565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15564",
    "data-name": "Group 15564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63126",
    "data-name": "Path 63126",
    d: "M103.148,463.728c-.168.036-.412-.887.075-1.889s1.354-1.392,1.43-1.238c.1.153-.465.687-.852,1.516C103.395,462.936,103.331,463.712,103.148,463.728Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15593",
    "data-name": "Group 15593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15592",
    "data-name": "Group 15592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15591",
    "data-name": "Group 15591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15590",
    "data-name": "Group 15590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15589",
    "data-name": "Group 15589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15588",
    "data-name": "Group 15588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15587",
    "data-name": "Group 15587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15586",
    "data-name": "Group 15586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15585",
    "data-name": "Group 15585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15584",
    "data-name": "Group 15584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15583",
    "data-name": "Group 15583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15582",
    "data-name": "Group 15582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15581",
    "data-name": "Group 15581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15580",
    "data-name": "Group 15580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15579",
    "data-name": "Group 15579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63127",
    "data-name": "Path 63127",
    d: "M96.762,452.822c-.08.167-.921-.1-1.963-.042-1.043.035-1.858.373-1.951.214-.105-.135.695-.8,1.923-.855S96.854,452.679,96.762,452.822Z",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15597",
    "data-name": "Group 15597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15596",
    "data-name": "Group 15596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63128",
    "data-name": "Path 63128",
    d: "M136.3,282.827c0,1.775,2.868,46.578-11.777,78.974,0,0-5.074,10.136-5.962,14.573s-19.879,77.9-19.879,77.9l-21.9-.8s-3.506-36.813.044-58.115,10.033-18.816,10.033-32.574S83.594,320.5,83.594,320.5s-4.784-7.8-6.415-22.9c-1.325-12.274,4.448-25.419,4.448-25.419l5.716-10.113,48.308-2.532Z",
    fill: "#50aa32"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15600",
    "data-name": "Group 15600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15599",
    "data-name": "Group 15599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15598",
    "data-name": "Group 15598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63129",
    "data-name": "Path 63129",
    d: "M136.3,282.827s.006-.516-.012-1.524-.053-2.517-.1-4.481c-.1-3.953-.241-9.772-.426-17.288l0-.119-.12.006-48.311,2.456-.106,0-.052.092-5.726,10.107-.006.011,0,.008A65.039,65.039,0,0,0,78,283.182a49.478,49.478,0,0,0-1.206,12.187,75.469,75.469,0,0,0,1.966,12.693,51.9,51.9,0,0,0,4.63,12.565l-.034-.1c.83,7.465,1.6,15.195,2.246,23.152.321,3.979.605,8.016.8,12.107.1,2.045.173,4.1.189,6.173.036,1.038-.041,2.065-.06,3.1a27.062,27.062,0,0,1-.383,3.081,20.372,20.372,0,0,1-2.073,5.872c-.97,1.871-2.058,3.72-2.97,5.674a53.424,53.424,0,0,0-3.934,12.4c-1.745,8.6-2.1,17.542-2.193,26.544-.039,11.9.563,23.57,1.543,34.868l.02.231.234.009,21.9.794.209.007.052-.2c6.344-24.611,12.266-47.61,17.483-68.293q.963-3.882,1.9-7.654c.321-1.267.533-2.529.923-3.725s.828-2.387,1.29-3.549c.938-2.32,1.95-4.569,2.983-6.761q.393-.819.782-1.631a16.612,16.612,0,0,0,.739-1.64q.68-1.658,1.345-3.287a132.514,132.514,0,0,0,6.915-24.934,217.444,217.444,0,0,0,3.3-36.735c.056-8.626-.294-13.307-.294-13.307s-.006.293.007.867.037,1.437.066,2.554c.062,2.248.1,5.576.043,9.884a221.65,221.65,0,0,1-3.45,36.677,132.65,132.65,0,0,1-6.956,24.845q-.665,1.619-1.343,3.267a16.3,16.3,0,0,1-.74,1.631q-.392.813-.787,1.634c-1.039,2.2-2.057,4.448-3,6.778-.466,1.168-.918,2.355-1.307,3.578s-.62,2.511-.938,3.752q-.94,3.766-1.909,7.646c-5.31,20.659-11.223,43.66-17.55,68.273l.261-.194-21.9-.805.254.24c-.974-11.275-1.573-22.944-1.535-34.815.1-8.985.448-17.9,2.179-26.441a52.923,52.923,0,0,1,3.89-12.283c.9-1.932,1.978-3.765,2.96-5.66a20.9,20.9,0,0,0,2.119-6.016,27.49,27.49,0,0,0,.39-3.144c.019-1.049.1-2.1.058-3.139-.017-2.08-.091-4.144-.193-6.194-.2-4.1-.489-8.14-.813-12.123-.658-7.964-1.431-15.7-2.269-23.166l0-.046-.029-.053a51.532,51.532,0,0,1-4.588-12.423,75.061,75.061,0,0,1-1.971-12.6,49.051,49.051,0,0,1,1.177-12.077,64.636,64.636,0,0,1,3.4-11.008l-.009.018,5.7-10.119-.157.1,48.3-2.608-.122-.112c.233,7.513.414,13.331.537,17.283.068,1.963.12,3.46.155,4.48S136.3,282.827,136.3,282.827Z",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15743",
    "data-name": "Group 15743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15603",
    "data-name": "Group 15603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63130",
    "data-name": "Path 63130",
    d: "M120.589,191.069s-13.046-2.3-11.786,14.431c.755,10.019,3.7,27.157,5.326,38.114.563,3.786,1.8,10.569,6.808,14.55l35.9,24.845,11.33-13.545-32.056-30.538-5.038-30.2Z",
    fill: "#143185"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15740",
    "data-name": "Group 15740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15738",
    "data-name": "Group 15738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15737",
    "data-name": "Group 15737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15604",
    "data-name": "Group 15604"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63131",
    "data-name": "Path 63131",
    d: "M122.116,130.774a16.422,16.422,0,0,1,6.1,13.918c-.2,2.554-.9,5.469.759,7.419,1.645,1.931,4.875,1.875,6.452,3.861,1.856,2.339.3,5.819.966,8.73a5.912,5.912,0,0,0,6.286,4.392,23.055,23.055,0,0,1-11.436,4.962l-3.2-4.108c1.212,1.438.89,3.73-.285,5.2a9.664,9.664,0,0,1-4.781,2.839,29.269,29.269,0,0,1-25.651-4.17",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15605",
    "data-name": "Group 15605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63132",
    "data-name": "Path 63132",
    d: "M74.092,153.344c.64-1.958,1.714-3.773,2.144-5.788.925-4.33-1.184-9.2.917-13.1,1.5-2.775,4.681-4.133,7.693-5.061s6.244-1.714,8.49-3.925c1.648-1.621,2.585-3.854,4.227-5.481,2.34-2.319,5.794-3.1,9.082-3.306a19.728,19.728,0,0,1,9.9,1.607,10.825,10.825,0,0,1,6.1,7.627c.264,1.628.064,3.334.577,4.9.564,1.724,1.918,3.065,2.753,4.675a8.674,8.674,0,0,1-2.169,10.4l-23.18,29.941c-4.869,1.839-16.668-.386-20.431-3.982S72.476,158.292,74.092,153.344Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15606",
    "data-name": "Group 15606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63133",
    "data-name": "Path 63133",
    d: "M123.2,142.086c-.955-6.8-6.125-14.83-12.876-13.587L89.48,135.5c-2.051.377-.582,3.722-.382,5.8l4.531,47c-.034.011-2.815,2.01-3.82,1.625a.283.283,0,0,0-.337.423c2.5,3.634,14.318,19.521,26.494,14.67,2.72-1.083-.285-9.654.034-12.829l-.362-8.112c-.27-4.141-.4-5.837-.4-5.8,0,0,8.616-2.12,9.548-13.645C125.256,158.9,124.258,149.639,123.2,142.086Z",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15620",
    "data-name": "Group 15620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15619",
    "data-name": "Group 15619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15618",
    "data-name": "Group 15618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15617",
    "data-name": "Group 15617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15616",
    "data-name": "Group 15616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15615",
    "data-name": "Group 15615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15614",
    "data-name": "Group 15614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15613",
    "data-name": "Group 15613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15612",
    "data-name": "Group 15612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15611",
    "data-name": "Group 15611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15610",
    "data-name": "Group 15610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15609",
    "data-name": "Group 15609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15608",
    "data-name": "Group 15608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15607",
    "data-name": "Group 15607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63134",
    "data-name": "Path 63134",
    d: "M121.745,152.549a1.464,1.464,0,0,1-1.3,1.581,1.4,1.4,0,0,1-1.606-1.2,1.466,1.466,0,0,1,1.293-1.583A1.4,1.4,0,0,1,121.745,152.549Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15634",
    "data-name": "Group 15634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15633",
    "data-name": "Group 15633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15632",
    "data-name": "Group 15632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15631",
    "data-name": "Group 15631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15630",
    "data-name": "Group 15630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15629",
    "data-name": "Group 15629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15628",
    "data-name": "Group 15628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15627",
    "data-name": "Group 15627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15626",
    "data-name": "Group 15626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15625",
    "data-name": "Group 15625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15624",
    "data-name": "Group 15624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15623",
    "data-name": "Group 15623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15622",
    "data-name": "Group 15622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15621",
    "data-name": "Group 15621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63135",
    "data-name": "Path 63135",
    d: "M107.554,153.438a1.465,1.465,0,0,1-1.295,1.581,1.4,1.4,0,0,1-1.607-1.2,1.467,1.467,0,0,1,1.293-1.583A1.4,1.4,0,0,1,107.554,153.438Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15649",
    "data-name": "Group 15649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15648",
    "data-name": "Group 15648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15647",
    "data-name": "Group 15647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15646",
    "data-name": "Group 15646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15645",
    "data-name": "Group 15645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15644",
    "data-name": "Group 15644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15643",
    "data-name": "Group 15643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15642",
    "data-name": "Group 15642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15641",
    "data-name": "Group 15641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15640",
    "data-name": "Group 15640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15639",
    "data-name": "Group 15639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15638",
    "data-name": "Group 15638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15637",
    "data-name": "Group 15637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15636",
    "data-name": "Group 15636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15635",
    "data-name": "Group 15635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63136",
    "data-name": "Path 63136",
    d: "M122.268,147.734c-.158.267-1.517-.592-3.218-.344-1.7.219-2.792,1.414-3.015,1.2-.107-.094.025-.555.5-1.092a3.879,3.879,0,0,1,4.975-.683C122.1,147.2,122.348,147.613,122.268,147.734Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15664",
    "data-name": "Group 15664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15663",
    "data-name": "Group 15663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15662",
    "data-name": "Group 15662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15661",
    "data-name": "Group 15661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15660",
    "data-name": "Group 15660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15659",
    "data-name": "Group 15659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15658",
    "data-name": "Group 15658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15657",
    "data-name": "Group 15657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15656",
    "data-name": "Group 15656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15655",
    "data-name": "Group 15655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15654",
    "data-name": "Group 15654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15653",
    "data-name": "Group 15653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15652",
    "data-name": "Group 15652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15651",
    "data-name": "Group 15651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15650",
    "data-name": "Group 15650"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63137",
    "data-name": "Path 63137",
    d: "M106.994,148.995c-.2.246-1.538-.724-3.367-.646-1.83.05-3.127,1.112-3.336.88-.1-.1.09-.54.657-1.02a4.435,4.435,0,0,1,2.656-1,4.316,4.316,0,0,1,2.693.811C106.88,148.462,107.092,148.884,106.994,148.995Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15679",
    "data-name": "Group 15679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15678",
    "data-name": "Group 15678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15677",
    "data-name": "Group 15677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15676",
    "data-name": "Group 15676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15675",
    "data-name": "Group 15675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15674",
    "data-name": "Group 15674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15673",
    "data-name": "Group 15673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15672",
    "data-name": "Group 15672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15671",
    "data-name": "Group 15671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15670",
    "data-name": "Group 15670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15669",
    "data-name": "Group 15669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15668",
    "data-name": "Group 15668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15667",
    "data-name": "Group 15667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15666",
    "data-name": "Group 15666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15665",
    "data-name": "Group 15665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63138",
    "data-name": "Path 63138",
    d: "M112.728,159.766a10.434,10.434,0,0,1,2.517-.657c.4-.072.772-.181.818-.46a2.041,2.041,0,0,0-.359-1.169l-1.421-2.964c-1.982-4.223-3.45-7.708-3.279-7.786s1.916,3.281,3.9,7.5q.718,1.563,1.373,2.986a2.328,2.328,0,0,1,.329,1.559,1.014,1.014,0,0,1-.615.638,2.775,2.775,0,0,1-.674.147A10.24,10.24,0,0,1,112.728,159.766Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15693",
    "data-name": "Group 15693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15692",
    "data-name": "Group 15692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15691",
    "data-name": "Group 15691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15690",
    "data-name": "Group 15690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15689",
    "data-name": "Group 15689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15688",
    "data-name": "Group 15688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15687",
    "data-name": "Group 15687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15686",
    "data-name": "Group 15686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15685",
    "data-name": "Group 15685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15684",
    "data-name": "Group 15684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15683",
    "data-name": "Group 15683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15682",
    "data-name": "Group 15682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15681",
    "data-name": "Group 15681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15680",
    "data-name": "Group 15680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63139",
    "data-name": "Path 63139",
    d: "M115.243,178.277a29.044,29.044,0,0,1-15.561-2.9s4.447,7.7,15.761,5.755Z",
    fill: "#ff9a6c"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15694",
    "data-name": "Group 15694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63140",
    "data-name": "Path 63140",
    d: "M107.935,164.352a2.472,2.472,0,0,1,.806-.958,1.98,1.98,0,0,1,1.361-.137,3.172,3.172,0,0,1,1.78.9,1.912,1.912,0,0,1,.449,1.881h0c-.176.657-1.157,1.017-1.827,1.135a3,3,0,0,1-1.958-.412,1.73,1.73,0,0,1-1-1.3A2.114,2.114,0,0,1,107.935,164.352Z",
    fill: "#ff9a6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15709",
    "data-name": "Group 15709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15708",
    "data-name": "Group 15708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15707",
    "data-name": "Group 15707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15706",
    "data-name": "Group 15706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15705",
    "data-name": "Group 15705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15704",
    "data-name": "Group 15704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15703",
    "data-name": "Group 15703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15702",
    "data-name": "Group 15702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15701",
    "data-name": "Group 15701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15700",
    "data-name": "Group 15700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15699",
    "data-name": "Group 15699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15698",
    "data-name": "Group 15698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15697",
    "data-name": "Group 15697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15696",
    "data-name": "Group 15696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15695",
    "data-name": "Group 15695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63141",
    "data-name": "Path 63141",
    d: "M108.257,162.14c.254-.035.389,1.671,1.942,2.769s3.354.771,3.386,1.009c.032.1-.38.362-1.146.442a4.256,4.256,0,0,1-2.818-.746,3.709,3.709,0,0,1-1.519-2.33C107.982,162.576,108.14,162.139,108.257,162.14Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15720",
    "data-name": "Group 15720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15719",
    "data-name": "Group 15719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15718",
    "data-name": "Group 15718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15717",
    "data-name": "Group 15717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15716",
    "data-name": "Group 15716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15715",
    "data-name": "Group 15715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15714",
    "data-name": "Group 15714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15713",
    "data-name": "Group 15713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15712",
    "data-name": "Group 15712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15711",
    "data-name": "Group 15711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15710",
    "data-name": "Group 15710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63142",
    "data-name": "Path 63142",
    d: "M106.856,142.845c-.122.439-1.707.357-3.533.721-1.834.327-3.279.981-3.553.617-.123-.175.105-.6.674-1.057a6.273,6.273,0,0,1,5.4-1.019C106.54,142.328,106.907,142.637,106.856,142.845Z",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15731",
    "data-name": "Group 15731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15730",
    "data-name": "Group 15730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15729",
    "data-name": "Group 15729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15728",
    "data-name": "Group 15728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15727",
    "data-name": "Group 15727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15726",
    "data-name": "Group 15726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15725",
    "data-name": "Group 15725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15724",
    "data-name": "Group 15724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15723",
    "data-name": "Group 15723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15722",
    "data-name": "Group 15722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15721",
    "data-name": "Group 15721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63143",
    "data-name": "Path 63143",
    d: "M121.3,141.984c-.288.381-1.554.106-3.043.2-1.491.051-2.729.451-3.047.1-.142-.172.03-.544.554-.925a4.67,4.67,0,0,1,2.427-.774,4.612,4.612,0,0,1,2.48.53C121.225,141.445,121.426,141.8,121.3,141.984Z",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15732",
    "data-name": "Group 15732"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63144",
    "data-name": "Path 63144",
    d: "M84.871,137.141c1.052-1.618,2.941-2.451,4.741-3.145a104.925,104.925,0,0,1,24.137-6.148c1.028,1.694.078,4-1.473,5.233s-3.543,1.72-5.4,2.414-3.758,1.763-4.522,3.591c-.813,1.944-.127,4.246-.841,6.228-1.229,3.412-5.989,4.511-7.2,7.929-.914,2.585.583,5.336.957,8.053A9.8,9.8,0,0,1,85.65,172.45q-.846-14.682-1.694-29.362C83.838,141.05,83.76,138.854,84.871,137.141Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15733",
    "data-name": "Group 15733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63145",
    "data-name": "Path 63145",
    d: "M65.154,161.866c1.546-1.385,3.484-2.583,4.1-4.565.9-2.887-1.422-6.28.072-8.909,1.361-2.4,5.374-2.277,6.639-4.727.989-1.913-.146-3.606.229-5.286s2.761-3.154,4.471-2.953L94.031,154.8c1.241,6.5,2.49,9.957,1.1,13.759a30.829,30.829,0,0,0-2.063,6.318c-.3,2.2.262,4.7,2.062,6-7.992.626-15.481-3.557-22.4-7.6l-7.325-4.28a5.351,5.351,0,0,1-2.013-1.677C62.312,165.538,63.608,163.252,65.154,161.866Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15734",
    "data-name": "Group 15734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63146",
    "data-name": "Path 63146",
    d: "M72.523,171.313a3.8,3.8,0,0,0,.854.164,7.289,7.289,0,0,0,2.489-.177,7.7,7.7,0,0,0,3.472-1.869,7.58,7.58,0,0,0,2.286-4.671,7.813,7.813,0,0,0-.262-3.065,12.464,12.464,0,0,0-1.484-2.97,11.772,11.772,0,0,1-1.531-3.082,3.972,3.972,0,0,1,.428-3.389c.727-.974,2.078-1.212,3.33-1.717a3.652,3.652,0,0,0,1.7-1.262,3.573,3.573,0,0,0,.55-2.1,22.707,22.707,0,0,0-.909-4.162,4.558,4.558,0,0,1-.013-2.042,2.85,2.85,0,0,1,1.154-1.62,7.992,7.992,0,0,1,4.042-1.081,8.656,8.656,0,0,0,4.119-1.211,7.765,7.765,0,0,0,2.819-3.056,12.806,12.806,0,0,0,1.041-3.83,17.867,17.867,0,0,1,.783-3.593,7.991,7.991,0,0,1,1.88-2.833,8.97,8.97,0,0,1,10.478-1.472,10.932,10.932,0,0,1,3.078,2.344,14.458,14.458,0,0,1,1.9,2.727.731.731,0,0,0-.076-.208c-.062-.132-.137-.337-.277-.586a10.481,10.481,0,0,0-1.415-2.054,10.852,10.852,0,0,0-3.093-2.454,9.377,9.377,0,0,0-5.1-1.129,9.533,9.533,0,0,0-5.771,2.553,8.376,8.376,0,0,0-2,2.967,18.153,18.153,0,0,0-.824,3.671,12.44,12.44,0,0,1-1.013,3.7,7.331,7.331,0,0,1-2.663,2.869,8.215,8.215,0,0,1-3.922,1.138,8.388,8.388,0,0,0-4.27,1.163,3.319,3.319,0,0,0-1.332,1.88,4.981,4.981,0,0,0,.008,2.25,23.043,23.043,0,0,1,.907,4.082,3.135,3.135,0,0,1-.466,1.833,3.22,3.22,0,0,1-1.5,1.105c-.6.252-1.239.425-1.858.688a3.8,3.8,0,0,0-1.643,1.181,4.376,4.376,0,0,0-.482,3.753,12.071,12.071,0,0,0,1.6,3.181,12.191,12.191,0,0,1,1.468,2.87,7.5,7.5,0,0,1,.278,2.925,7.337,7.337,0,0,1-2.138,4.52,7.634,7.634,0,0,1-3.337,1.881A8.676,8.676,0,0,1,72.523,171.313Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15735",
    "data-name": "Group 15735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63147",
    "data-name": "Path 63147",
    d: "M61.863,157.541a1.666,1.666,0,0,0-.264.653,2.867,2.867,0,0,0,.343,1.982,3.041,3.041,0,0,0,1.023,1.075,3.187,3.187,0,0,0,1.707.455,3.992,3.992,0,0,0,3.5-2.223,5.334,5.334,0,0,0,.57-2.436,7.437,7.437,0,0,0-.562-2.641c-.634-1.73-1.786-3.415-1.811-5.436a3.691,3.691,0,0,1,.928-2.747,4.036,4.036,0,0,1,2.905-.908,9.792,9.792,0,0,0,3.46-.358,3.008,3.008,0,0,0,1.423-1.2,4.283,4.283,0,0,0,.584-1.763,14.1,14.1,0,0,0-.289-3.553,7.812,7.812,0,0,1,.185-3.293,8.315,8.315,0,0,1,3.72-4.881A11.753,11.753,0,0,1,84.827,129a16.363,16.363,0,0,0,5.058-.8,10.549,10.549,0,0,0,3.581-2.253,10.443,10.443,0,0,0,1.962-2.519,7.573,7.573,0,0,0,.951-2.536,14.624,14.624,0,0,1-1.108,2.446,10.644,10.644,0,0,1-1.982,2.419,10.439,10.439,0,0,1-3.516,2.134,16.28,16.28,0,0,1-4.967.721,12.056,12.056,0,0,0-5.738,1.281,8.722,8.722,0,0,0-3.942,5.128,8.255,8.255,0,0,0-.205,3.477,13.915,13.915,0,0,1,.286,3.437,2.981,2.981,0,0,1-1.722,2.589,9.565,9.565,0,0,1-3.293.33,4.46,4.46,0,0,0-3.209,1.048,4.116,4.116,0,0,0-1.043,3.073,7.85,7.85,0,0,0,.732,2.977c.387.906.819,1.747,1.148,2.588a7.139,7.139,0,0,1,.563,2.505,5.034,5.034,0,0,1-.5,2.284,3.712,3.712,0,0,1-3.212,2.111,2.968,2.968,0,0,1-1.588-.384,2.886,2.886,0,0,1-.98-.977,2.843,2.843,0,0,1-.407-1.874C61.761,157.765,61.887,157.551,61.863,157.541Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15736",
    "data-name": "Group 15736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63148",
    "data-name": "Path 63148",
    d: "M146.09,162.315a3.169,3.169,0,0,1-.027,2.09,2.751,2.751,0,0,1-1.661,1.684,2.887,2.887,0,0,1-2.933-.8,2.654,2.654,0,0,1-.687-1.674,5.52,5.52,0,0,1,.306-2.023c.424-1.353,1.29-2.825,1.157-4.589a6.448,6.448,0,0,0-2.431-4.619,7.546,7.546,0,0,0-2.491-1.311,11.1,11.1,0,0,0-2.846-.41,14.921,14.921,0,0,1-2.763-.288,3.678,3.678,0,0,1-2.151-1.337,4.516,4.516,0,0,1-.777-2.365,8.977,8.977,0,0,1,.207-2.465,18.686,18.686,0,0,0,.716-4.676,7.086,7.086,0,0,0-1.427-3.883,9.131,9.131,0,0,0-2.6-2.2,17.235,17.235,0,0,1-2.082-1.439,5.372,5.372,0,0,1-1.31-1.683c-.007,0,0,.05.034.14a2.318,2.318,0,0,0,.16.392,4.269,4.269,0,0,0,1,1.286,15.854,15.854,0,0,0,2.061,1.522,9.058,9.058,0,0,1,2.483,2.178,6.806,6.806,0,0,1,1.306,3.7,18.737,18.737,0,0,1-.752,4.572,9.41,9.41,0,0,0-.23,2.581,4.951,4.951,0,0,0,.853,2.605,4.132,4.132,0,0,0,2.407,1.516,15.183,15.183,0,0,0,2.852.305,10.733,10.733,0,0,1,2.733.386,7.141,7.141,0,0,1,2.342,1.225,6.033,6.033,0,0,1,2.288,4.29c.141,1.613-.66,3.025-1.1,4.447a5.85,5.85,0,0,0-.3,2.165,3,3,0,0,0,.806,1.873,3.161,3.161,0,0,0,3.258.821,3.047,3.047,0,0,0,1.824-3.5A1.669,1.669,0,0,0,146.09,162.315Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15739",
    "data-name": "Group 15739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63149",
    "data-name": "Path 63149",
    d: "M136.527,240.644V229.577c1.239-6.205.652-13.565-2.234-19.238a105.4,105.4,0,0,0-6.941-10.553L116.335,185.5c-6.058,4.412-15.543,1.224-23.683-1.74,0,0-8.041,4.448-11.781,8.633-3.929,4.4,9.5,59.447,9.5,59.447-6.088,12.179-13.945,22.971-15.137,34.1l63.6,2.451-2.7-29.161Z",
    fill: "#143185"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15742",
    "data-name": "Group 15742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15741",
    "data-name": "Group 15741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63150",
    "data-name": "Path 63150",
    d: "M135.651,259.537a5.7,5.7,0,0,1-.049-1.246c.01-.907.023-2.041.038-3.389.049-2.973.113-6.87.183-11.179.084-4.368.2-8.322.336-11.183.067-1.43.139-2.587.2-3.385a5.73,5.73,0,0,1,.154-1.238,5.754,5.754,0,0,1,.048,1.246c-.01.907-.023,2.041-.038,3.389-.049,2.973-.112,6.871-.183,11.181-.083,4.366-.2,8.32-.336,11.181-.067,1.43-.139,2.587-.2,3.386A5.763,5.763,0,0,1,135.651,259.537Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15744",
    "data-name": "Group 15744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63151",
    "data-name": "Path 63151",
    d: "M164.7,269.6s6.194.336,10.038,2.742,10.006,6.136,12.552,10.773c1.169,2.128-2.163,2.579-3.808,1.342s-4.163-3.562-5.413-3.849l-1.251-.286a83.523,83.523,0,0,0,3.807,7.555c1.3,1.964,2.416,5.321-1.462,5.475,0,0-2.616,3.4-5.257.881,0,0-2.061,3.085-5.381-1.193,0,0-1.932,2.446-2.739,1.514s-3.449-2.423-4.221-5.479a108.679,108.679,0,0,0-4.015-10.491Z",
    fill: "#ffbf9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15751",
    "data-name": "Group 15751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15746",
    "data-name": "Group 15746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63152",
    "data-name": "Path 63152",
    d: "M303.509,183.664c.694.009,29.086-2.981,29.086-2.981s2.4-11.545,2.275-14.545-2.152-22.85-2.152-22.85l10.634-5.03s14.212,47.922,11.105,51.906-8.929,7.544-9.429,7.565-27.507,11.988-46.3,5.769S303.509,183.664,303.509,183.664Z",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15750",
    "data-name": "Group 15750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15747",
    "data-name": "Group 15747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63153",
    "data-name": "Path 63153",
    d: "M278.631,209.532c4.183,4.146,11.383,7.6,23.394,4.6,23.765-5.934,41.571-10.955,48.656-14.8s4.32-20.78,4.916-21.549c1.8-2.317-.174-7.3-2.73-8.076-7.266-2.2-19.922-1.334-20.555-.67-3.734,3.916-.328,8.68-.328,8.68l-31.334,4.1a52.13,52.13,0,0,0-11.51.737",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15749",
    "data-name": "Group 15749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15748",
    "data-name": "Group 15748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63154",
    "data-name": "Path 63154",
    d: "M289.14,182.553s.253-.066.752-.161,1.242-.221,2.219-.344a51.229,51.229,0,0,1,8.548-.359h-.025l31.321-4.2-.151.348a8.34,8.34,0,0,1-1.443-5.147,5.886,5.886,0,0,1,.9-2.661,7.811,7.811,0,0,1,.864-1.141,1.487,1.487,0,0,1,.408-.219l.357-.09c.24-.063.471-.084.707-.128a61.7,61.7,0,0,1,11.685-.246,40.7,40.7,0,0,1,6.078.838c.507.116,1.01.262,1.518.393a3.821,3.821,0,0,1,1.434.835A7.08,7.08,0,0,1,356.075,173a6.792,6.792,0,0,1,.414,3.259,3.823,3.823,0,0,1-.629,1.592c-.093.1-.081.372-.094.632l.009.8c.075,2.149.174,4.339.118,6.546a27.911,27.911,0,0,1-1.49,9.222,9.038,9.038,0,0,1-2.605,3.827,9.194,9.194,0,0,1-1.975,1.177c-.666.353-1.361.626-2.036.94-2.733,1.173-5.487,2.127-8.193,3.025s-5.376,1.71-7.987,2.475c-10.452,3.043-19.958,5.428-27.941,7.417a54.493,54.493,0,0,1-5.76,1.2,31.133,31.133,0,0,1-5.246.279,21.994,21.994,0,0,1-8.185-1.777,18.965,18.965,0,0,1-4.5-2.8,11.567,11.567,0,0,1-1.343-1.271c.025-.027.461.441,1.41,1.19a19.678,19.678,0,0,0,4.514,2.7,22.018,22.018,0,0,0,8.114,1.672,31.206,31.206,0,0,0,5.191-.316,54.613,54.613,0,0,0,5.717-1.226c7.969-2.035,17.463-4.456,27.894-7.52,2.606-.77,5.269-1.588,7.966-2.487s5.441-1.855,8.148-3.021c.666-.312,1.358-.583,2.01-.931a8.7,8.7,0,0,0,1.877-1.117,8.544,8.544,0,0,0,2.449-3.617,27.5,27.5,0,0,0,1.452-9.046c.055-2.188-.042-4.355-.117-6.519l-.009-.819c0-.139.009-.279.021-.426a1.662,1.662,0,0,1,.044-.249,1.123,1.123,0,0,1,.078-.173l.049-.08a3.325,3.325,0,0,0,.539-1.368,6.3,6.3,0,0,0-.386-3,6.578,6.578,0,0,0-1.626-2.52,3.325,3.325,0,0,0-1.238-.727c-.5-.128-.987-.271-1.484-.386a40.371,40.371,0,0,0-6-.835,61.727,61.727,0,0,0-11.577.217c-.223.042-.461.064-.672.12l-.321.078a1.514,1.514,0,0,0-.208.094,7.2,7.2,0,0,0-.808,1.061,5.416,5.416,0,0,0-.837,2.457,7.912,7.912,0,0,0,1.344,4.848l.2.3-.348.044-31.345,4.011h-.025a54.466,54.466,0,0,0-8.516.237c-.977.1-1.722.205-2.223.279S289.14,182.553,289.14,182.553Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15769",
    "data-name": "Group 15769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15752",
    "data-name": "Group 15752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17500",
    "data-name": "Rectangle 17500",
    d: "M0,0H26.2a0,0,0,0,1,0,0V276.239a11.973,11.973,0,0,1-11.973,11.973h-2.25A11.973,11.973,0,0,1,0,276.239V0A0,0,0,0,1,0,0Z",
    transform: "matrix(-0.486, -0.874, 0.874, -0.486, 204.312, 215.123)",
    fill: "#ffe81c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15753",
    "data-name": "Group 15753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17501",
    "data-name": "Rectangle 17501",
    d: "M0,0H60.771a2.237,2.237,0,0,1,2.237,2.237V17.761A2.237,2.237,0,0,1,60.771,20H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(406.703 93.867) rotate(-119.102)",
    fill: "#ffe81c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15754",
    "data-name": "Group 15754"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17502",
    "data-name": "Rectangle 17502",
    width: 50.766,
    height: 19.997,
    rx: 3.244,
    transform: "matrix(-0.486, -0.874, 0.874, -0.486, 371.674, 110.67)",
    fill: "#ffe81c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15755",
    "data-name": "Group 15755"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17503",
    "data-name": "Rectangle 17503",
    width: 27.417,
    height: 31.057,
    transform: "translate(380.917 90.838) rotate(-119.102)",
    fill: "#ffe81c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15757",
    "data-name": "Group 15757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15756",
    "data-name": "Group 15756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63155",
    "data-name": "Path 63155",
    d: "M429.391,59.858c.07.125-47.3,26.625-105.785,59.18C265.1,151.6,217.628,177.9,217.558,177.77s47.287-26.62,105.795-59.187C381.84,86.028,429.321,59.732,429.391,59.858Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15758",
    "data-name": "Group 15758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63156",
    "data-name": "Path 63156",
    d: "M106.564,259.41c17.792,31.964,55.325,45.013,83.831,29.146s37.192-54.643,19.4-86.607S154.47,156.935,125.964,172.8,88.772,227.445,106.564,259.41Zm87.784-48.863c12.467,22.4,6.381,49.569-13.594,60.688s-46.275,1.975-58.743-20.424-6.381-49.569,13.594-60.687S181.88,188.149,194.348,210.547Z",
    fill: "#ffe81c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15759",
    "data-name": "Group 15759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17504",
    "data-name": "Rectangle 17504",
    d: "M6.517,0H33.6a6.517,6.517,0,0,1,6.517,6.517V7.742A6.517,6.517,0,0,1,33.6,14.26H6.518A6.518,6.518,0,0,1,0,7.742V6.517A6.517,6.517,0,0,1,6.517,0Z",
    transform: "translate(248.517 198.655) rotate(-119.102)",
    fill: "#ffe81c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15760",
    "data-name": "Group 15760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17505",
    "data-name": "Rectangle 17505",
    d: "M6.517,0H33.6a6.518,6.518,0,0,1,6.518,6.518V7.742A6.517,6.517,0,0,1,33.6,14.26H6.517A6.517,6.517,0,0,1,0,7.743V6.517A6.517,6.517,0,0,1,6.517,0Z",
    transform: "translate(273.814 184.575) rotate(-119.102)",
    fill: "#ffe81c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15762",
    "data-name": "Group 15762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15761",
    "data-name": "Group 15761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63157",
    "data-name": "Path 63157",
    d: "M244.36,161.952c.126-.068,3.184,5.3,6.829,11.986s6.5,12.166,6.372,12.235-3.183-5.3-6.829-11.986S244.233,162.021,244.36,161.952Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15764",
    "data-name": "Group 15764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15763",
    "data-name": "Group 15763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63158",
    "data-name": "Path 63158",
    d: "M232.752,170.254c.126-.07,3.11,5.052,6.665,11.438s6.337,11.623,6.211,11.693-3.109-5.051-6.666-11.439S232.627,170.324,232.752,170.254Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15766",
    "data-name": "Group 15766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15765",
    "data-name": "Group 15765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63159",
    "data-name": "Path 63159",
    d: "M269.812,148.066c.126-.07,3.235,5.276,6.943,11.938s6.615,12.123,6.489,12.193-3.234-5.275-6.944-11.94S269.686,148.136,269.812,148.066Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15768",
    "data-name": "Group 15768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15767",
    "data-name": "Group 15767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63160",
    "data-name": "Path 63160",
    d: "M257.6,155.441c.126-.069,3.169,5.241,6.8,11.86s6.466,12.042,6.34,12.112-3.169-5.241-6.8-11.862S257.471,155.51,257.6,155.441Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16238",
    "data-name": "Group 16238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16226",
    "data-name": "Group 16226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15950",
    "data-name": "Group 15950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15933",
    "data-name": "Group 15933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15932",
    "data-name": "Group 15932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15777",
    "data-name": "Group 15777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15776",
    "data-name": "Group 15776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15775",
    "data-name": "Group 15775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15774",
    "data-name": "Group 15774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15773",
    "data-name": "Group 15773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15772",
    "data-name": "Group 15772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15771",
    "data-name": "Group 15771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15770",
    "data-name": "Group 15770"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63161",
    "data-name": "Path 63161",
    d: "M330.131,119.372a4.727,4.727,0,0,0,2.019-9.186,4.917,4.917,0,0,0-4.271-8.3,5.884,5.884,0,0,0-8.864-4.838,6.616,6.616,0,0,0-8.146-.18,4.706,4.706,0,0,0-4.169,7.976",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15931",
    "data-name": "Group 15931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15913",
    "data-name": "Group 15913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15782",
    "data-name": "Group 15782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15781",
    "data-name": "Group 15781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15780",
    "data-name": "Group 15780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15779",
    "data-name": "Group 15779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15778",
    "data-name": "Group 15778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63162",
    "data-name": "Path 63162",
    d: "M309.844,101.532l1.038,0a20.052,20.052,0,0,1,19.934,18.5c.752,9.691,1.458,20.407,1.378,25.605-.165,10.762-10.935,12.4-10.935,12.4l.872,12.933-26.118-.889-2.168-46.9C292.915,112.01,298.645,102.152,309.844,101.532Z",
    fill: "#ffbf9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15793",
    "data-name": "Group 15793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15792",
    "data-name": "Group 15792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15791",
    "data-name": "Group 15791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15790",
    "data-name": "Group 15790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15789",
    "data-name": "Group 15789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15788",
    "data-name": "Group 15788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15787",
    "data-name": "Group 15787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15786",
    "data-name": "Group 15786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15785",
    "data-name": "Group 15785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15784",
    "data-name": "Group 15784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15783",
    "data-name": "Group 15783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63163",
    "data-name": "Path 63163",
    d: "M321.349,158.029a26.115,26.115,0,0,1-14.09-4.17s3.462,8.147,14.2,7.21Z",
    fill: "#ff9a6c"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15807",
    "data-name": "Group 15807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15806",
    "data-name": "Group 15806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15805",
    "data-name": "Group 15805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15804",
    "data-name": "Group 15804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15803",
    "data-name": "Group 15803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15802",
    "data-name": "Group 15802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15801",
    "data-name": "Group 15801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15800",
    "data-name": "Group 15800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15799",
    "data-name": "Group 15799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15798",
    "data-name": "Group 15798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15797",
    "data-name": "Group 15797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15796",
    "data-name": "Group 15796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15795",
    "data-name": "Group 15795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15794",
    "data-name": "Group 15794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63164",
    "data-name": "Path 63164",
    d: "M324.909,130.145a1.537,1.537,0,0,1-1.487,1.546,1.469,1.469,0,0,1-1.58-1.39,1.537,1.537,0,0,1,1.485-1.547A1.472,1.472,0,0,1,324.909,130.145Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15822",
    "data-name": "Group 15822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15821",
    "data-name": "Group 15821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15820",
    "data-name": "Group 15820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15819",
    "data-name": "Group 15819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15818",
    "data-name": "Group 15818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15817",
    "data-name": "Group 15817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15816",
    "data-name": "Group 15816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15815",
    "data-name": "Group 15815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15814",
    "data-name": "Group 15814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15813",
    "data-name": "Group 15813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15812",
    "data-name": "Group 15812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15811",
    "data-name": "Group 15811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15810",
    "data-name": "Group 15810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15809",
    "data-name": "Group 15809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15808",
    "data-name": "Group 15808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63165",
    "data-name": "Path 63165",
    d: "M328.486,125.295c-.191.2-1.352-.666-3.006-.666-1.652-.025-2.869.823-3.047.62-.088-.091.107-.452.636-.835a4.227,4.227,0,0,1,2.441-.744,4.055,4.055,0,0,1,2.392.78C328.41,124.842,328.581,125.205,328.486,125.295Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15836",
    "data-name": "Group 15836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15835",
    "data-name": "Group 15835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15834",
    "data-name": "Group 15834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15833",
    "data-name": "Group 15833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15832",
    "data-name": "Group 15832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15831",
    "data-name": "Group 15831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15830",
    "data-name": "Group 15830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15829",
    "data-name": "Group 15829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15828",
    "data-name": "Group 15828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15827",
    "data-name": "Group 15827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15826",
    "data-name": "Group 15826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15825",
    "data-name": "Group 15825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15824",
    "data-name": "Group 15824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15823",
    "data-name": "Group 15823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63166",
    "data-name": "Path 63166",
    d: "M309.987,129.433a1.536,1.536,0,0,1-1.486,1.546,1.47,1.47,0,0,1-1.58-1.391,1.538,1.538,0,0,1,1.485-1.547A1.471,1.471,0,0,1,309.987,129.433Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15851",
    "data-name": "Group 15851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15850",
    "data-name": "Group 15850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15849",
    "data-name": "Group 15849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15848",
    "data-name": "Group 15848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15847",
    "data-name": "Group 15847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15846",
    "data-name": "Group 15846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15845",
    "data-name": "Group 15845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15844",
    "data-name": "Group 15844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15843",
    "data-name": "Group 15843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15842",
    "data-name": "Group 15842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15841",
    "data-name": "Group 15841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15840",
    "data-name": "Group 15840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15839",
    "data-name": "Group 15839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15838",
    "data-name": "Group 15838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15837",
    "data-name": "Group 15837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63167",
    "data-name": "Path 63167",
    d: "M312.229,125.554c-.192.2-1.355-.665-3.007-.666-1.652-.024-2.869.823-3.047.62-.088-.09.105-.451.637-.834a4.214,4.214,0,0,1,2.44-.745,4.048,4.048,0,0,1,2.392.781C312.15,125.1,312.322,125.465,312.229,125.554Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15865",
    "data-name": "Group 15865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15864",
    "data-name": "Group 15864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15863",
    "data-name": "Group 15863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15862",
    "data-name": "Group 15862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15861",
    "data-name": "Group 15861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15860",
    "data-name": "Group 15860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15859",
    "data-name": "Group 15859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15858",
    "data-name": "Group 15858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15857",
    "data-name": "Group 15857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15856",
    "data-name": "Group 15856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15855",
    "data-name": "Group 15855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15854",
    "data-name": "Group 15854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15853",
    "data-name": "Group 15853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15852",
    "data-name": "Group 15852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63168",
    "data-name": "Path 63168",
    d: "M318.194,137.838a10.866,10.866,0,0,1,2.687-.477c.423-.042.823-.125.895-.413a2.155,2.155,0,0,0-.278-1.253q-.591-1.535-1.239-3.22c-1.721-4.583-2.965-8.352-2.78-8.42s1.73,3.593,3.451,8.177c.414,1.131.81,2.208,1.186,3.239a2.437,2.437,0,0,1,.214,1.658,1.055,1.055,0,0,1-.7.615,2.859,2.859,0,0,1-.717.1A10.848,10.848,0,0,1,318.194,137.838Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15875",
    "data-name": "Group 15875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15874",
    "data-name": "Group 15874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15873",
    "data-name": "Group 15873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15872",
    "data-name": "Group 15872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15871",
    "data-name": "Group 15871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15870",
    "data-name": "Group 15870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15869",
    "data-name": "Group 15869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15868",
    "data-name": "Group 15868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15867",
    "data-name": "Group 15867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15866",
    "data-name": "Group 15866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63169",
    "data-name": "Path 63169",
    d: "M313.683,119.195c-.22.419-1.636-.04-3.381-.1-1.743-.1-3.215.223-3.373-.213-.068-.208.243-.583.873-.917a5.236,5.236,0,0,1,2.62-.543,5.054,5.054,0,0,1,2.525.783C313.525,118.593,313.78,119,313.683,119.195Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15885",
    "data-name": "Group 15885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15884",
    "data-name": "Group 15884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15883",
    "data-name": "Group 15883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15882",
    "data-name": "Group 15882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15881",
    "data-name": "Group 15881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15880",
    "data-name": "Group 15880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15879",
    "data-name": "Group 15879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15878",
    "data-name": "Group 15878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15877",
    "data-name": "Group 15877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15876",
    "data-name": "Group 15876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63170",
    "data-name": "Path 63170",
    d: "M328.587,118.475c-.349.375-1.713-.019-3.355-.043-1.64-.071-3.032.244-3.35-.15-.14-.191.08-.567.688-.921a5.349,5.349,0,0,1,2.73-.607,5.257,5.257,0,0,1,2.674.763C328.552,117.9,328.742,118.293,328.587,118.475Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15894",
    "data-name": "Group 15894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15893",
    "data-name": "Group 15893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15892",
    "data-name": "Group 15892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15891",
    "data-name": "Group 15891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15890",
    "data-name": "Group 15890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15889",
    "data-name": "Group 15889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15888",
    "data-name": "Group 15888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15887",
    "data-name": "Group 15887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15886",
    "data-name": "Group 15886"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63171",
    "data-name": "Path 63171",
    d: "M329.8,115.1s-2.818-6.748-6.063-8.331c-3.929-1.915-5.636,2.4-9.382,1.338s-7.5-2.9-11.337-.011c-4.2,3.16-2.246,5.392-2.519,10.166-1.109,19.357-4.662,24.821-5.64,15.7-.107-1-2.877-1.8-3.275-6.024-.516-5.475-.707-12.122.527-16,1.039-3.271,2.913-5.527,6.268-8.011,5.3-3.92,12.554-3.983,17.482-3.472S330.27,106.66,329.8,115.1Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15903",
    "data-name": "Group 15903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15902",
    "data-name": "Group 15902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15901",
    "data-name": "Group 15901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15900",
    "data-name": "Group 15900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15899",
    "data-name": "Group 15899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15898",
    "data-name": "Group 15898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15897",
    "data-name": "Group 15897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15896",
    "data-name": "Group 15896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15895",
    "data-name": "Group 15895"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63172",
    "data-name": "Path 63172",
    d: "M295.542,133.668a2.92,2.92,0,0,0-3.145-2.825c-2.008.184-4.245,1.317-4.125,5.465.213,7.359,7.556,5.628,7.563,5.416C295.839,141.581,295.659,136.746,295.542,133.668Z",
    fill: "#ffbf9d"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15912",
    "data-name": "Group 15912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15911",
    "data-name": "Group 15911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15910",
    "data-name": "Group 15910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15909",
    "data-name": "Group 15909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15908",
    "data-name": "Group 15908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15907",
    "data-name": "Group 15907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15906",
    "data-name": "Group 15906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15905",
    "data-name": "Group 15905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15904",
    "data-name": "Group 15904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63173",
    "data-name": "Path 63173",
    d: "M294.154,139c-.033-.023-.126.093-.34.2a1.277,1.277,0,0,1-.957.047,3.171,3.171,0,0,1-1.55-2.8,4.239,4.239,0,0,1,.306-1.846,1.477,1.477,0,0,1,.935-1.011.653.653,0,0,1,.767.329c.105.2.062.351.1.363.021.018.154-.128.086-.43a.817.817,0,0,0-.3-.453.973.973,0,0,0-.714-.167,1.8,1.8,0,0,0-1.306,1.18,4.35,4.35,0,0,0-.385,2.063c.09,1.482.889,2.848,1.961,3.124a1.374,1.374,0,0,0,1.167-.228C294.146,139.18,294.18,139.014,294.154,139Z",
    fill: "#ff9a6c"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15921",
    "data-name": "Group 15921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15920",
    "data-name": "Group 15920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15919",
    "data-name": "Group 15919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15918",
    "data-name": "Group 15918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15917",
    "data-name": "Group 15917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15916",
    "data-name": "Group 15916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15915",
    "data-name": "Group 15915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15914",
    "data-name": "Group 15914"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63174",
    "data-name": "Path 63174",
    d: "M295.729,119.412a7,7,0,0,0,3.112,1.449,2.4,2.4,0,0,0,2.668-1.68c.089-.512-.035-1.107.3-1.5.4-.471,1.144-.32,1.761-.253,2.138.233,4.645-2.122,5.2-4.2a1.919,1.919,0,0,0,2.564.539,6.873,6.873,0,0,0,1.778-1.571,3.023,3.023,0,0,1,2.529-1.255,7.312,7.312,0,0,0,1.6.357c.966-.083,1.441-1.213,1.591-2.172s.266-2.077,1.086-2.6c.759-.481,1.741-.2,2.631-.065s2.038-.072,2.268-.941a1.744,1.744,0,0,0-.325-1.335,4.767,4.767,0,0,0-5.62-1.822,6.458,6.458,0,0,0-11.863-1.287,6.554,6.554,0,0,0-10.485,2.358,4.751,4.751,0,0,0-5.378,6.9,4.511,4.511,0,0,0-2.493,3.585c-.032,1.523,1.446,3.045,2.918,2.649a2.631,2.631,0,0,0,4.542,2.638",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15930",
    "data-name": "Group 15930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15929",
    "data-name": "Group 15929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15928",
    "data-name": "Group 15928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15927",
    "data-name": "Group 15927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15926",
    "data-name": "Group 15926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15925",
    "data-name": "Group 15925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15924",
    "data-name": "Group 15924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15923",
    "data-name": "Group 15923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15922",
    "data-name": "Group 15922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63175",
    "data-name": "Path 63175",
    d: "M319.411,104.532a.369.369,0,0,1,0,.135c-.01.088-.015.222-.048.393a4.629,4.629,0,0,1-.538,1.416,5.262,5.262,0,0,1-1.637,1.734,4.9,4.9,0,0,1-3.017.851l.125-.163a2.664,2.664,0,0,1-.153,2.031,7.647,7.647,0,0,1-1.265,1.806,5.488,5.488,0,0,1-.826.842,2.576,2.576,0,0,1-1.167.429,2.688,2.688,0,0,1-2.366-.856l.275-.078a5.518,5.518,0,0,1-2.352,3.811,4.024,4.024,0,0,1-2.419.785,7.259,7.259,0,0,1-2.379-.53l.2-.086a5.794,5.794,0,0,1-1.748,2.266,3.088,3.088,0,0,1-2.566.69,4.052,4.052,0,0,1-3.111-3.181l.166.078a3.8,3.8,0,0,1-2.529.364,4.114,4.114,0,0,1-1.761-.792,3.554,3.554,0,0,1-.819-.9,1.766,1.766,0,0,1-.186-.381,4.414,4.414,0,0,0,1.08,1.184,4.074,4.074,0,0,0,1.717.715,3.636,3.636,0,0,0,2.388-.384l.138-.078.028.156a3.824,3.824,0,0,0,2.944,2.948,2.8,2.8,0,0,0,2.329-.653,5.536,5.536,0,0,0,1.643-2.15l.058-.136.139.049a7.006,7.006,0,0,0,2.276.5,3.713,3.713,0,0,0,2.233-.73,5.225,5.225,0,0,0,2.225-3.592l.047-.348.228.271a2.391,2.391,0,0,0,2.089.755,2.28,2.28,0,0,0,1.035-.372,5.342,5.342,0,0,0,.779-.789,7.443,7.443,0,0,0,1.236-1.728,2.416,2.416,0,0,0,.166-1.838L314,108.8l.185.013a4.724,4.724,0,0,0,2.89-.77A5.244,5.244,0,0,0,318.7,106.4,5.681,5.681,0,0,0,319.411,104.532Z",
    fill: "#455a64"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15949",
    "data-name": "Group 15949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15948",
    "data-name": "Group 15948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15947",
    "data-name": "Group 15947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15946",
    "data-name": "Group 15946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15945",
    "data-name": "Group 15945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15944",
    "data-name": "Group 15944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15943",
    "data-name": "Group 15943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15942",
    "data-name": "Group 15942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15941",
    "data-name": "Group 15941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15940",
    "data-name": "Group 15940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15939",
    "data-name": "Group 15939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15938",
    "data-name": "Group 15938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15937",
    "data-name": "Group 15937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15936",
    "data-name": "Group 15936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15935",
    "data-name": "Group 15935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15934",
    "data-name": "Group 15934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63176",
    "data-name": "Path 63176",
    d: "M318.165,143.333c-.051-.273-1.846.17-3.5-1.049s-1.933-3.179-2.187-3.131c-.119,0-.243.513-.065,1.326a4.6,4.6,0,0,0,1.725,2.638,4.01,4.01,0,0,0,2.908.765C317.811,143.764,318.206,143.453,318.165,143.333Z",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16225",
    "data-name": "Group 16225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16083",
    "data-name": "Group 16083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16082",
    "data-name": "Group 16082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15968",
    "data-name": "Group 15968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15967",
    "data-name": "Group 15967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15966",
    "data-name": "Group 15966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15965",
    "data-name": "Group 15965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15964",
    "data-name": "Group 15964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15963",
    "data-name": "Group 15963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15962",
    "data-name": "Group 15962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15961",
    "data-name": "Group 15961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15960",
    "data-name": "Group 15960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15959",
    "data-name": "Group 15959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15958",
    "data-name": "Group 15958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15957",
    "data-name": "Group 15957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15956",
    "data-name": "Group 15956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15955",
    "data-name": "Group 15955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15954",
    "data-name": "Group 15954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15953",
    "data-name": "Group 15953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15952",
    "data-name": "Group 15952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15951",
    "data-name": "Group 15951"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63177",
    "data-name": "Path 63177",
    d: "M373.626,423.115l7.1,24.2s26.978.9,28.726,5.247l-46.416,15.46-12.617-37.243Z",
    fill: "#455a64"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15987",
    "data-name": "Group 15987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15986",
    "data-name": "Group 15986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15985",
    "data-name": "Group 15985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15984",
    "data-name": "Group 15984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15983",
    "data-name": "Group 15983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15982",
    "data-name": "Group 15982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15981",
    "data-name": "Group 15981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15980",
    "data-name": "Group 15980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15979",
    "data-name": "Group 15979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15978",
    "data-name": "Group 15978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15977",
    "data-name": "Group 15977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15976",
    "data-name": "Group 15976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15975",
    "data-name": "Group 15975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15974",
    "data-name": "Group 15974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15973",
    "data-name": "Group 15973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15972",
    "data-name": "Group 15972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15971",
    "data-name": "Group 15971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15970",
    "data-name": "Group 15970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15969",
    "data-name": "Group 15969"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63178",
    "data-name": "Path 63178",
    d: "M365.708,450.079a2,2,0,0,0-.59,2.6,1.92,1.92,0,0,0,2.572.607,2.108,2.108,0,0,0,.61-2.756,1.992,1.992,0,0,0-2.745-.335",
    fill: "#e0e0e0"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16005",
    "data-name": "Group 16005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16004",
    "data-name": "Group 16004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16003",
    "data-name": "Group 16003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16002",
    "data-name": "Group 16002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16001",
    "data-name": "Group 16001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16000",
    "data-name": "Group 16000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15999",
    "data-name": "Group 15999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15998",
    "data-name": "Group 15998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15997",
    "data-name": "Group 15997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15996",
    "data-name": "Group 15996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15995",
    "data-name": "Group 15995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15994",
    "data-name": "Group 15994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15993",
    "data-name": "Group 15993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15992",
    "data-name": "Group 15992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15991",
    "data-name": "Group 15991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15990",
    "data-name": "Group 15990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15989",
    "data-name": "Group 15989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15988",
    "data-name": "Group 15988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63179",
    "data-name": "Path 63179",
    d: "M406.84,450.813s2.366.211,2.617,1.744l-46.416,15.46-1.125-3.8,44.924-13.4",
    fill: "#263238"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16024",
    "data-name": "Group 16024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16023",
    "data-name": "Group 16023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16022",
    "data-name": "Group 16022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16021",
    "data-name": "Group 16021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16020",
    "data-name": "Group 16020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16019",
    "data-name": "Group 16019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16018",
    "data-name": "Group 16018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16017",
    "data-name": "Group 16017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16016",
    "data-name": "Group 16016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16015",
    "data-name": "Group 16015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16014",
    "data-name": "Group 16014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16013",
    "data-name": "Group 16013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16012",
    "data-name": "Group 16012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16011",
    "data-name": "Group 16011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16010",
    "data-name": "Group 16010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16009",
    "data-name": "Group 16009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16008",
    "data-name": "Group 16008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16007",
    "data-name": "Group 16007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16006",
    "data-name": "Group 16006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63180",
    "data-name": "Path 63180",
    d: "M381.4,446.823c.068.229-1.031.709-1.9,1.809-.9,1.078-1.149,2.251-1.388,2.231-.224.026-.337-1.442.743-2.756S381.384,446.6,381.4,446.823Z",
    fill: "#fff"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16043",
    "data-name": "Group 16043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16042",
    "data-name": "Group 16042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16041",
    "data-name": "Group 16041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16040",
    "data-name": "Group 16040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16039",
    "data-name": "Group 16039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16038",
    "data-name": "Group 16038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16037",
    "data-name": "Group 16037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16036",
    "data-name": "Group 16036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16035",
    "data-name": "Group 16035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16034",
    "data-name": "Group 16034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16033",
    "data-name": "Group 16033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16032",
    "data-name": "Group 16032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16031",
    "data-name": "Group 16031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16030",
    "data-name": "Group 16030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16029",
    "data-name": "Group 16029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16028",
    "data-name": "Group 16028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16027",
    "data-name": "Group 16027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16026",
    "data-name": "Group 16026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16025",
    "data-name": "Group 16025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63181",
    "data-name": "Path 63181",
    d: "M386.943,447.215c.125.2-.728.915-1.179,2.13-.486,1.2-.335,2.3-.564,2.368-.2.107-.8-1.169-.211-2.669S386.866,447,386.943,447.215Z",
    fill: "#fff"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16062",
    "data-name": "Group 16062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16061",
    "data-name": "Group 16061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16060",
    "data-name": "Group 16060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16059",
    "data-name": "Group 16059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16058",
    "data-name": "Group 16058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16057",
    "data-name": "Group 16057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16056",
    "data-name": "Group 16056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16055",
    "data-name": "Group 16055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16054",
    "data-name": "Group 16054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16053",
    "data-name": "Group 16053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16052",
    "data-name": "Group 16052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16051",
    "data-name": "Group 16051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16050",
    "data-name": "Group 16050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16049",
    "data-name": "Group 16049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16048",
    "data-name": "Group 16048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16047",
    "data-name": "Group 16047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16046",
    "data-name": "Group 16046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16045",
    "data-name": "Group 16045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16044",
    "data-name": "Group 16044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63182",
    "data-name": "Path 63182",
    d: "M391.649,452.121c-.19.116-.882-.911-.714-2.346s1.064-2.282,1.223-2.125c.19.144-.276,1.039-.4,2.219C391.613,451.046,391.867,452.023,391.649,452.121Z",
    fill: "#fff"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16081",
    "data-name": "Group 16081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16080",
    "data-name": "Group 16080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16079",
    "data-name": "Group 16079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16078",
    "data-name": "Group 16078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16077",
    "data-name": "Group 16077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16076",
    "data-name": "Group 16076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16075",
    "data-name": "Group 16075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16074",
    "data-name": "Group 16074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16073",
    "data-name": "Group 16073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16072",
    "data-name": "Group 16072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16071",
    "data-name": "Group 16071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16070",
    "data-name": "Group 16070"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16069",
    "data-name": "Group 16069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16068",
    "data-name": "Group 16068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16067",
    "data-name": "Group 16067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16066",
    "data-name": "Group 16066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16065",
    "data-name": "Group 16065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16064",
    "data-name": "Group 16064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16063",
    "data-name": "Group 16063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63183",
    "data-name": "Path 63183",
    d: "M379.173,441.488c-.026.239-1.17.272-2.422.787-1.262.488-2.116,1.249-2.3,1.1-.186-.121.508-1.284,1.991-1.868S379.225,441.274,379.173,441.488Z",
    fill: "#fff"
  })))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16216",
    "data-name": "Group 16216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16215",
    "data-name": "Group 16215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16101",
    "data-name": "Group 16101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16100",
    "data-name": "Group 16100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16099",
    "data-name": "Group 16099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16098",
    "data-name": "Group 16098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16097",
    "data-name": "Group 16097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16096",
    "data-name": "Group 16096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16095",
    "data-name": "Group 16095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16094",
    "data-name": "Group 16094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16093",
    "data-name": "Group 16093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16092",
    "data-name": "Group 16092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16091",
    "data-name": "Group 16091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16090",
    "data-name": "Group 16090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16089",
    "data-name": "Group 16089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16088",
    "data-name": "Group 16088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16087",
    "data-name": "Group 16087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16086",
    "data-name": "Group 16086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16085",
    "data-name": "Group 16085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16084",
    "data-name": "Group 16084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63184",
    "data-name": "Path 63184",
    d: "M265.29,423.328l-10.106,23.1s20.087,18.032,18.635,22.483l-45.5-17.988,14.271-36.641Z",
    fill: "#455a64"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16120",
    "data-name": "Group 16120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16119",
    "data-name": "Group 16119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16118",
    "data-name": "Group 16118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16117",
    "data-name": "Group 16117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16116",
    "data-name": "Group 16116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16115",
    "data-name": "Group 16115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16114",
    "data-name": "Group 16114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16113",
    "data-name": "Group 16113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16112",
    "data-name": "Group 16112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16111",
    "data-name": "Group 16111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16110",
    "data-name": "Group 16110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16109",
    "data-name": "Group 16109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16108",
    "data-name": "Group 16108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16107",
    "data-name": "Group 16107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16106",
    "data-name": "Group 16106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16105",
    "data-name": "Group 16105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16104",
    "data-name": "Group 16104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16103",
    "data-name": "Group 16103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16102",
    "data-name": "Group 16102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63185",
    "data-name": "Path 63185",
    d: "M241.9,438.9a2,2,0,0,0-2.123,1.612,1.92,1.92,0,0,0,1.58,2.118,2.107,2.107,0,0,0,2.239-1.719c.038-.981-.913-2.134-1.888-2.021",
    fill: "#e0e0e0"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16138",
    "data-name": "Group 16138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16137",
    "data-name": "Group 16137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16136",
    "data-name": "Group 16136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16135",
    "data-name": "Group 16135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16134",
    "data-name": "Group 16134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16133",
    "data-name": "Group 16133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16130",
    "data-name": "Group 16130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16129",
    "data-name": "Group 16129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16128",
    "data-name": "Group 16128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16127",
    "data-name": "Group 16127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16126",
    "data-name": "Group 16126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16125",
    "data-name": "Group 16125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16124",
    "data-name": "Group 16124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16123",
    "data-name": "Group 16123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16122",
    "data-name": "Group 16122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16121",
    "data-name": "Group 16121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63186",
    "data-name": "Path 63186",
    d: "M272.935,465.894s1.676,1.682.884,3.018l-45.5-17.988,1.583-3.637,43.03,18.607",
    fill: "#263238"
  }))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16157",
    "data-name": "Group 16157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16156",
    "data-name": "Group 16156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16155",
    "data-name": "Group 16155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16154",
    "data-name": "Group 16154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16153",
    "data-name": "Group 16153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16152",
    "data-name": "Group 16152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16151",
    "data-name": "Group 16151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16150",
    "data-name": "Group 16150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16149",
    "data-name": "Group 16149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16148",
    "data-name": "Group 16148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16147",
    "data-name": "Group 16147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16146",
    "data-name": "Group 16146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16145",
    "data-name": "Group 16145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16144",
    "data-name": "Group 16144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16143",
    "data-name": "Group 16143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16142",
    "data-name": "Group 16142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16141",
    "data-name": "Group 16141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16140",
    "data-name": "Group 16140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16139",
    "data-name": "Group 16139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63187",
    "data-name": "Path 63187",
    d: "M256.012,446.489c-.095.22-1.245-.119-2.621.163-1.383.246-2.327.986-2.5.817-.188-.124.668-1.321,2.34-1.633C254.9,445.508,256.141,446.3,256.012,446.489Z",
    fill: "#fff"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16176",
    "data-name": "Group 16176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16175",
    "data-name": "Group 16175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16174",
    "data-name": "Group 16174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16173",
    "data-name": "Group 16173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16172",
    "data-name": "Group 16172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16171",
    "data-name": "Group 16171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16170",
    "data-name": "Group 16170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16169",
    "data-name": "Group 16169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16168",
    "data-name": "Group 16168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16167",
    "data-name": "Group 16167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16166",
    "data-name": "Group 16166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16165",
    "data-name": "Group 16165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16164",
    "data-name": "Group 16164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16163",
    "data-name": "Group 16163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16162",
    "data-name": "Group 16162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16161",
    "data-name": "Group 16161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16160",
    "data-name": "Group 16160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16159",
    "data-name": "Group 16159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16158",
    "data-name": "Group 16158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63188",
    "data-name": "Path 63188",
    d: "M260,450.35c-.034.235-1.146.232-2.272.874-1.145.608-1.737,1.549-1.954,1.451-.223-.047.138-1.409,1.553-2.18S260.083,450.136,260,450.35Z",
    fill: "#fff"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16195",
    "data-name": "Group 16195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16194",
    "data-name": "Group 16194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16193",
    "data-name": "Group 16193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16192",
    "data-name": "Group 16192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16191",
    "data-name": "Group 16191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16190",
    "data-name": "Group 16190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16189",
    "data-name": "Group 16189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16188",
    "data-name": "Group 16188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16187",
    "data-name": "Group 16187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16186",
    "data-name": "Group 16186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16185",
    "data-name": "Group 16185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16184",
    "data-name": "Group 16184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16183",
    "data-name": "Group 16183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16182",
    "data-name": "Group 16182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16181",
    "data-name": "Group 16181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16180",
    "data-name": "Group 16180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16179",
    "data-name": "Group 16179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16178",
    "data-name": "Group 16178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16177",
    "data-name": "Group 16177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63189",
    "data-name": "Path 63189",
    d: "M260.456,457.132c-.22-.032-.091-1.264.961-2.255s2.282-1.065,2.3-.843c.054.233-.879.619-1.729,1.446C261.119,456.286,260.686,457.2,260.456,457.132Z",
    fill: "#fff"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16214",
    "data-name": "Group 16214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16213",
    "data-name": "Group 16213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16212",
    "data-name": "Group 16212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16211",
    "data-name": "Group 16211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16210",
    "data-name": "Group 16210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16209",
    "data-name": "Group 16209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16208",
    "data-name": "Group 16208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16207",
    "data-name": "Group 16207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16206",
    "data-name": "Group 16206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16205",
    "data-name": "Group 16205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16204",
    "data-name": "Group 16204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16203",
    "data-name": "Group 16203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16202",
    "data-name": "Group 16202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16201",
    "data-name": "Group 16201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16200",
    "data-name": "Group 16200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16199",
    "data-name": "Group 16199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16198",
    "data-name": "Group 16198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16197",
    "data-name": "Group 16197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16196",
    "data-name": "Group 16196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63190",
    "data-name": "Path 63190",
    d: "M257.732,440.969c-.173.166-1.071-.544-2.361-.955-1.281-.437-2.425-.4-2.465-.639-.065-.211,1.214-.656,2.726-.151S257.91,440.838,257.732,440.969Z",
    fill: "#fff"
  })))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16217",
    "data-name": "Group 16217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63191",
    "data-name": "Path 63191",
    d: "M282.325,296.428l-15.944,64.659s-28.752,48.4-33.619,72.619l26.3,10.345S278.191,397.4,283.8,388.84a68.458,68.458,0,0,1,8.662-10.667,16.73,16.73,0,0,0,4.364-7.564l12.07-46.132Z",
    fill: "#1b3d9e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16221",
    "data-name": "Group 16221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16218",
    "data-name": "Group 16218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63192",
    "data-name": "Path 63192",
    d: "M275.534,286.1s2.217,17.311,18.882,24.987l35.121,57.2s2.758,18.6,8.057,34.274c5.26,15.559,15.856,45.864,15.856,45.864l28.889-10.8-18.412-62.944-3.012-21.83-28.664-72.952-24.619-14.763Z",
    fill: "#1b3d9e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16220",
    "data-name": "Group 16220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16219",
    "data-name": "Group 16219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63193",
    "data-name": "Path 63193",
    d: "M275.534,286.1s.172-.126.527-.365l1.593-1.061,6.238-4.117,23.66-15.541.076-.05.079.047,24.639,14.728.054.032.023.059c8.021,20.37,17.811,45.232,28.719,72.931l.01.027,0,.029c.955,6.9,1.977,14.285,3.021,21.828l-.008-.036c4.978,17.008,10.3,35.191,15.785,53.935q1.324,4.527,2.634,9.007l.068.232-.226.085-28.89,10.793-.247.092-.085-.248c-5.011-14.51-9.835-28.479-14.412-41.735-1.149-3.309-2.28-6.586-3.22-9.869s-1.791-6.535-2.555-9.755q-2.274-9.663-3.7-18.831l.029.081C314.985,344.93,303.026,325.4,294.3,311.152l.058.051a32.764,32.764,0,0,1-11.034-8.384,34.686,34.686,0,0,1-5.393-8.655,35.152,35.152,0,0,1-2.006-5.96c-.17-.689-.261-1.219-.322-1.573s-.07-.536-.07-.536.036.177.106.53.175.878.356,1.562a36.758,36.758,0,0,0,2.065,5.92,34.879,34.879,0,0,0,5.421,8.577,32.653,32.653,0,0,0,10.99,8.276l.037.017.021.035,35.191,57.155.023.036.007.045c.961,6.08,2.2,12.363,3.718,18.789.766,3.212,1.611,6.46,2.56,9.729s2.07,6.534,3.224,9.847c4.586,13.251,9.418,27.215,14.439,41.72l-.332-.155,28.887-10.8-.158.316q-1.309-4.477-2.635-9.006l-15.768-53.94-.006-.018,0-.019c-1.039-7.544-2.055-14.932-3.005-21.83l.015.055-28.61-72.973.077.091-24.6-14.8.154,0-23.69,15.382-6.3,4.069-1.628,1.042C275.73,285.98,275.534,286.1,275.534,286.1Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16222",
    "data-name": "Group 16222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63194",
    "data-name": "Path 63194",
    d: "M290.957,162.52s-8.415,6.483-12.509,13.721c-4.9,8.665-5.428,21.523-5.582,41.477-.143,18.467,2.618,23.593,1.551,30.549-2.085,13.593-3.636,59.2-3.636,59.2s26.968-10.37,32.238-14.952l5.269-4.581,33.788,11.167-6.819-41.516-4.676-51.753-5.991-27.451-1.047-10.768L294.6,155.908Z",
    fill: "#50aa32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16224",
    "data-name": "Group 16224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16223",
    "data-name": "Group 16223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63195",
    "data-name": "Path 63195",
    d: "M322.532,167.031c.353.065-.833,2.434-2.916,5.915l-.085.142-.159-.062c-2.935-1.136-6.812-2.568-11.052-4.114-4.782-1.743-9.1-3.361-12.191-4.623-1.546-.63-2.788-1.161-3.639-1.545a7.7,7.7,0,0,1-1.3-.649,7.77,7.77,0,0,1,1.376.461l3.7,1.39,12.237,4.477c4.241,1.547,8.109,3.024,11.021,4.233l-.243.08C321.44,169.3,322.729,167.052,322.532,167.031Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16237",
    "data-name": "Group 16237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16227",
    "data-name": "Group 16227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63196",
    "data-name": "Path 63196",
    d: "M357.446,145.435s-2.135-3.327-4.161-6.4-5.075-4.572-5.564-6.181-3.182-8.721-3.613-10.493a22.527,22.527,0,0,1-.516-5.219s2.207-.947,3.27,2.218c.639,1.9,2.675,8.351,3.114,8.667s1.048-.147,1.048-.147a75.087,75.087,0,0,1-2.356-7.375c-.1-1.17.312-8.925.312-8.925a2.343,2.343,0,0,1,2.659,1.487c1.049,1.974,1.088,7.01,1.088,7.01l1.588,5.583-.551-5.523.8-10.144a3.817,3.817,0,0,1,3.2,2.973c.672,2.743-.216,6.559.236,7.376s.935,5.712.935,5.712.549-11.906,1.817-12.248,2.317.925,2.135,3.327-.228,7.474.432,9.717,7.43,10.958,6.871,14.835a63.374,63.374,0,0,0-.621,6.98H357.923Z",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16228",
    "data-name": "Group 16228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63197",
    "data-name": "Path 63197",
    d: "M316.762,175.415c.65.245,28.362,7.1,28.362,7.1s6.191-10.036,7.094-12.9,5.759-22.217,5.759-22.217l11.712-1.107s-2.962,49.9-7.24,52.584-10.965,4.052-11.442,3.9-29.945,1.9-45.5-10.347S316.762,175.415,316.762,175.415Z",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16236",
    "data-name": "Group 16236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16229",
    "data-name": "Group 16229",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63198",
    "data-name": "Path 63198",
    d: "M296.9,201.822a21.2,21.2,0,0,0,11.331,6.663c7.354,1.62,23,4.481,23,4.481l-.764-7.677-34.046-3.644"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16233",
    "data-name": "Group 16233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16230",
    "data-name": "Group 16230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63199",
    "data-name": "Path 63199",
    d: "M284.561,191.262c2.521,5.322,8.115,11.018,20.429,12.289,24.366,2.516,42.817,3.86,50.788,2.658s11.14-18.066,11.962-18.586c2.478-1.567,2.324-6.924.184-8.523-6.082-4.545-18.276-8.04-19.1-7.631-4.844,2.409-3.265,8.048-3.265,8.048L314.7,172.7a52.193,52.193,0,0,0-11.074-3.227",
    fill: "#143185"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16232",
    "data-name": "Group 16232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16231",
    "data-name": "Group 16231"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63200",
    "data-name": "Path 63200",
    d: "M303.63,169.476s.261.024.762.1,1.243.216,2.2.433a51.1,51.1,0,0,1,8.159,2.574l-.024-.008,30.878,6.722-.261.276a8.343,8.343,0,0,1,.4-5.33,5.879,5.879,0,0,1,1.75-2.2,7.711,7.711,0,0,1,1.2-.778,1.508,1.508,0,0,1,.458-.068l.366.038c.247.023.471.082.709.121a61.714,61.714,0,0,1,11.069,3.748,40.717,40.717,0,0,1,5.429,2.858c.438.282.861.591,1.294.887a3.827,3.827,0,0,1,1.064,1.274,7.065,7.065,0,0,1,.733,3.16,6.788,6.788,0,0,1-.72,3.2,3.843,3.843,0,0,1-1.134,1.283c-.121.06-.2.322-.3.563l-.263.752c-.661,2.046-1.314,4.139-2.118,6.194a27.894,27.894,0,0,1-4.543,8.164,9.044,9.044,0,0,1-3.752,2.71,9.15,9.15,0,0,1-2.258.434c-.747.106-1.493.125-2.235.191-2.969.172-5.883.13-8.733.053s-5.637-.223-8.353-.394c-10.863-.7-20.613-1.7-28.8-2.543a54.45,54.45,0,0,1-5.823-.837,31.166,31.166,0,0,1-5.028-1.524,22,22,0,0,1-7.09-4.459,18.914,18.914,0,0,1-3.277-4.167,11.6,11.6,0,0,1-.83-1.652c.033-.017.283.572.92,1.6a19.711,19.711,0,0,0,3.326,4.073,22.039,22.039,0,0,0,7.059,4.335,31.205,31.205,0,0,0,4.988,1.471,55.037,55.037,0,0,0,5.792.795c8.186.8,17.937,1.758,28.788,2.43,2.713.164,5.495.3,8.338.376s5.747.109,8.689-.066c.732-.066,1.475-.085,2.207-.19a8.7,8.7,0,0,0,2.145-.411,8.536,8.536,0,0,0,3.534-2.566,27.474,27.474,0,0,0,4.446-8.011c.8-2.038,1.445-4.109,2.111-6.169l.271-.773c.049-.13.1-.259.165-.394a1.645,1.645,0,0,1,.126-.218,1.226,1.226,0,0,1,.132-.137l.074-.058a3.327,3.327,0,0,0,.972-1.1,6.3,6.3,0,0,0,.659-2.951,6.57,6.57,0,0,0-.671-2.923,3.3,3.3,0,0,0-.916-1.1c-.423-.289-.835-.592-1.264-.869a40.352,40.352,0,0,0-5.357-2.829,61.652,61.652,0,0,0-10.959-3.739c-.224-.037-.455-.1-.673-.116l-.328-.036a1.525,1.525,0,0,0-.227.017,7.285,7.285,0,0,0-1.122.723,5.43,5.43,0,0,0-1.624,2.024,7.927,7.927,0,0,0-.388,5.017l.082.352-.342-.076-30.837-6.907-.012,0-.012-.006a54.527,54.527,0,0,0-8.088-2.677c-.953-.237-1.689-.394-2.185-.495S303.63,169.476,303.63,169.476Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16235",
    "data-name": "Group 16235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16234",
    "data-name": "Group 16234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63201",
    "data-name": "Path 63201",
    d: "M355.778,189.17a6.682,6.682,0,0,1-1.994-.867,20.245,20.245,0,0,1-4.208-3.142,20.8,20.8,0,0,1-3.278-4.1,6.828,6.828,0,0,1-.945-1.958,43.94,43.94,0,0,0,4.586,5.687A40.5,40.5,0,0,0,355.778,189.17Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16246",
    "data-name": "Group 16246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16241",
    "data-name": "Group 16241"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16239",
    "data-name": "Group 16239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63202",
    "data-name": "Path 63202",
    d: "M138.223,271.526s6.194.336,10.038,2.741,10.006,6.137,12.552,10.774c1.169,2.128-2.163,2.578-3.808,1.342s-4.163-3.563-5.413-3.849l-1.25-.286a83.573,83.573,0,0,0,3.806,7.555c1.3,1.964,2.416,5.321-1.462,5.475,0,0-2.616,3.4-5.257.881,0,0-2.061,3.084-5.38-1.194,0,0-1.933,2.447-2.74,1.514s-3.449-2.423-4.221-5.479a108.361,108.361,0,0,0-4.015-10.49Z",
    fill: "#ffbf9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16240",
    "data-name": "Group 16240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63203",
    "data-name": "Path 63203",
    d: "M85.463,189.975a14.91,14.91,0,0,0-7.793,5.853c-2.383,3.661-3.109,10.047-2.431,14.724,1.441,9.943,6.006,26.741,8.567,37.519.885,3.724,2.7,10.377,8.028,13.914L129.719,284.7l10.13-15.036-34.542-28.149-6.826-38.582Z",
    fill: "#1b3d9e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16243",
    "data-name": "Group 16243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16242",
    "data-name": "Group 16242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63204",
    "data-name": "Path 63204",
    d: "M78.911,227.917a2.584,2.584,0,0,1,.123.395l.312,1.172c.271,1.058.659,2.578,1.157,4.528.992,3.965,2.42,9.674,4.189,16.749a19.6,19.6,0,0,0,6.237,9.882,38.21,38.21,0,0,0,5.538,3.682L102.561,268l27.292,16.483-.349.078c1.158-1.721,2.4-3.558,3.644-5.412,2.205-3.27,4.375-6.49,6.486-9.623l.051.344-34.239-28.187-.052-.043-.015-.065c-2.263-9.515-3.9-17.3-4.934-22.72-.52-2.708-.877-4.824-1.107-6.263-.1-.7-.183-1.247-.241-1.64-.051-.371-.062-.563-.062-.563s.051.186.121.553c.071.391.17.933.3,1.631.267,1.431.659,3.539,1.212,6.238,1.1,5.4,2.795,13.174,5.1,22.67l-.067-.107,34.312,28.1.182.149-.131.195c-2.111,3.133-4.28,6.354-6.483,9.625l-3.646,5.411-.138.2-.212-.128L102.318,268.4l-6.081-3.693a38.5,38.5,0,0,1-5.582-3.746,19.927,19.927,0,0,1-6.306-10.11l-4.034-16.792-1.066-4.55-.265-1.184A2.663,2.663,0,0,1,78.911,227.917Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16245",
    "data-name": "Group 16245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16244",
    "data-name": "Group 16244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63205",
    "data-name": "Path 63205",
    d: "M79.534,195.328A2.361,2.361,0,0,1,80.3,195a13.27,13.27,0,0,1,2.215-.5,13.076,13.076,0,0,1,7.391,1,14.691,14.691,0,0,1,5.522,5.03,9,9,0,0,1,1.008,2.042,2.133,2.133,0,0,1,.176.818,20.237,20.237,0,0,0-1.489-2.655,15.7,15.7,0,0,0-5.447-4.768,13.739,13.739,0,0,0-7.118-1.1C80.686,195.049,79.559,195.417,79.534,195.328Z",
    fill: "#263238"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPassword);
export default __webpack_public_path__ + "static/media/newPassword.2a3a9a6ff35420dd97082143b6438899.svg";
export { ForwardRef as ReactComponent };